import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";

const Faqs = () => {
  return (
    <div>
      <Helmet>
        <title>FAQs | Idexcel</title>
        <meta content="" name="keywords" />
        <meta content="" name="description" />
      </Helmet>
      {/* //banner section  */}
      <motion.div
        className="Productright"
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
      >
      <Container fluid className="we-care-banner-container p-0">
        <section className="we-care-banner-section"></section>
      </Container>
      </motion.div>

      <Container className="mb-5">
        <section className="px-xl-5" style={{textAlign: "justify"}}>
          <h2 className="text-center mb-4 section-title">
            <span className="textgrad"> FAQ's </span>
          </h2>
          <h3 className="subtitle">Where do you find your candidates?</h3>
          <p>
            Our recruiting team maintains a proprietary database of candidates.
            We seek out referrals, which helps us find passive candidates. Also,
            our staffing team has access to several resume searching tools such
            as Dice, Monster, CareerBuilder, etc. We also use social media
            platforms to stay connected to candidates and our clients.
          </p>
          <h3 className="subtitle">Can you help me look for a job?</h3>
          <p>
            Yes, Idexcel places candidate in three ways - Direct Placement,
            Contract to Hire and Contract positions. We work with professionals
            having different skillsets and skill levels. Whether you are at an
            entry level, or upper management, we can help you find the best
            career opportunity.
          </p>
          <h3 className="subtitle">How do you shortlist the candidates?</h3>
          <p>
            At Idexcel, we follow extensive screening methods, and this is what
            sets us apart from other recruiting firms. We qualify only the best
            possible candidates for any given requirement and follow a four-step
            process in order to find the best possible fit for our client’s
            specific needs.
          </p>
          <h3 className="subtitle">Initial Telephonic Screening</h3>
          <p>
            Idexcel’s staffing specialists conduct a detailed phone screening
            with every candidate in order to ensure that they are able to assess
            the qualification, education, interests, experience and skill level
            of each candidate. Our recruiting staffs also evaluate the
            candidate’s areas of interest, availability, location and other
            expectations.
          </p>
          <h3 className="subtitle">Interview</h3>
          <p>
            Idexcel's staffing team schedules in-person interviews, where the
            candidate is evaluated not only in terms of technical abilities, but
            also on professionalism, soft skills and abilities. We gather
            additional information during this process, and ensure that the
            candidate is well aware of the client’s expectations. The candidate
            is evaluated thoroughly before moving on to the next level.
          </p>
          <h3 className="subtitle">Managerial References</h3>
          <p>
            Every candidate is expected to provide a minimum of three managerial
            references. We ensure that these references are valid and then
            contact the reference to gather additional information regarding the
            candidate’s experience, level of skill, and technical
            responsibilities. Also, feedback pertaining to the candidate’s
            reliability, team skills, and potential for rehire is collected. On
            getting a positive outcome from all the three references, we approve
            the candidate to be moved to the final phase of screening.
          </p>
          <h3 className="subtitle">Account Manager Screening</h3>
          <p>
            In the final step, Idexcel’s Account Manager reconfirms the
            candidate’s expertise, and evaluates the shortlisted candidates for
            the best match. The Account Manager knows the exact requirements of
            the client, and is ultimately responsible for filling the position.
            When the Account Manager confirms the expertise of the candidate, he
            or she is finalized for further evaluation by the client.
          </p>
          <p>
            Usually, the initial screening process is conducted over several
            candidates and only one or two best performants matching the
            client’s exact requirements are chosen after rigorous screening.
          </p>
          <h3 className="subtitle">
            How do you check the background of the candidate?
          </h3>
          <p>
            We do the basic background checks, and can perform additional
            testing based on the client’s request.
          </p>
          <h3 className="subtitle">
            How many recruiters are assigned to each requisition?
          </h3>
          <p>
            Based on the requirement or urgency, we usually assign 1-5
            recruiters for any given requisition.
          </p>
        </section>
      </Container>
    </div>
  );
};

export default Faqs;
